import { AutosizeTextarea } from '../ui/autosize-textarea.jsx';
import { FormControl, FormDescription, FormField, FormItem, FormLabel, FormMessage, } from '../ui/form.jsx';
export var TextareaBlock = function (_a) {
    var description = _a.description, _b = _a.emptyAsNull, emptyAsNull = _b === void 0 ? true : _b, form = _a.form, label = _a.label, labelClassName = _a.labelClassName, name = _a.name, inputProps = _a.inputProps;
    return (<FormField control={form.control} name={name} render={function (_a) {
            var _b;
            var field = _a.field;
            var customOnChange = (inputProps !== null && inputProps !== void 0 ? inputProps : {}).onChange;
            var handleChange = function (e) {
                if (customOnChange) {
                    customOnChange(e);
                }
                else if (emptyAsNull) {
                    field.onChange(e.target.value === '' ? null : e.target.value);
                }
                else {
                    field.onChange(e);
                }
            };
            return (<FormItem>
            {label && <FormLabel className={labelClassName}>{label}</FormLabel>}
            <FormControl>
              <AutosizeTextarea {...field} {...inputProps} value={(_b = field.value) !== null && _b !== void 0 ? _b : ''} onChange={handleChange}/>
            </FormControl>
            {description && <FormDescription>{description}</FormDescription>}
            <FormMessage />
          </FormItem>);
        }}/>);
};
